var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFailure = function SvgFailure(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73,
    height: 73,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF4246",
    fillRule: "evenodd",
    d: "M26.174 26.174a2.086 2.086 0 0 1 2.95 0l7.376 7.375 7.376-7.375a2.086 2.086 0 0 1 2.95 2.95L39.45 36.5l7.377 7.376c.76.76.812 1.962.152 2.781l-.152.17a2.086 2.086 0 0 1-2.95 0L36.5 39.448l-7.376 7.377a2.086 2.086 0 1 1-2.95-2.95l7.375-7.376-7.375-7.376a2.086 2.086 0 0 1-.152-2.781z",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 36.5,
    r: 33,
    stroke: "#FF4246",
    strokeWidth: 6
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFailure);
export default ForwardRef;